export default "__VITE_ASSET__DBBKXmmL__"